import { http } from '../../../../libs/util';

// const customer_brief_hash = {};

export default {
  // 用户信息更新不频繁，使用缓存，避免多次http请求
  async briefInfo(id) {
    const { customer } = await http.cacheGet('customer/brief', { id });
    return customer;
  }
}
